/* eslint-disable max-lines */
import lahiApi from '../../api/lahi-api';
import { sendCalculationErrorGtm, sendCalculationCtaGtm } from './lib/lahi-gtm';
const LAHI_SET_VHK_MODAL_ID = 'LAHI_SET_VHK_MODAL_ID';
const LAHI_SET_CTA_TEXT = 'LAHI_SET_CTA_TEXT';
const LAHI_SET_VHK_OPEN_IN_MODAL = 'LAHI_SET_VHK_OPEN_IN_MODAL';
const LAHI_SET_BOOKMARK_ID = 'LAHI_SET_BOOKMARK_ID';
const LAHI_SET_CALCULATOR_TABS = 'LAHI_SET_CALCULATOR_TABS';
const LAHI_SET_INIT_BACKEND_DATA = 'LAHI_SET_INIT_BACKEND_DATA';
const LAHI_SET_SESSION_ID = 'LAHI_SET_SESSION_ID';
const LAHI_SET_INIT_TECHNICAL_ERROR = 'LAHI_SET_INIT_TECHNICAL_ERROR';
const LAHI_SET_SELECTED_TAB_INDEX = 'LAHI_SET_SELECTED_TAB_INDEX';
const LAHI_SET_LAHI_PRODUCT_IDS = 'LAHI_SET_LAHI_PRODUCT_IDS';
const LAHI_SET_CALCULATION_RESULT = 'LAHI_SET_CALCULATION_RESULT';
const LAHI_SET_CALCULATION_IN_PROGRESS = 'LAHI_SET_CALCULATION_IN_PROGRESS';
const LAHI_SET_CALCULATION_TECHNICAL_ERROR = 'LAHI_SET_CALCULATION_TECHNICAL_ERROR';
const LAHI_SET_HAS_CALCULATION = 'LAHI_SET_HAS_CALCULATION';
const LAHI_SET_CALCULATION_LAHI_PRODUCT_IDS = 'LAHI_SET_CALCULATION_LAHI_PRODUCT_IDS';
const LAHI_SET_ALL_LAHI_PRODUCT_ID_JSONS = 'LAHI_SET_ALL_LAHI_PRODUCT_ID_JSONS';
const LAHI_SET_CALCULATION_LAHI_PRODUCT_ID_JSONS = 'LAHI_SET_CALCULATION_LAHI_PRODUCT_ID_JSONS';
const LAHI_SET_SW_JSON_PATH = 'LAHI_SET_SW_JSON_PATH';
const LAHI_SET_SELECTED_LAHI_PRODUCT = 'LAHI_SET_SELECTED_LAHI_PRODUCT';
const LAHI_SET_IS_PRODUCT_APR_DISCOUNTED = 'LAHI_SET_IS_PRODUCT_APR_DISCOUNTED';
const LAHI_SET_SEND_IN_EMAIL_TECHNICAL_FAILURE = 'LAHI_SET_SEND_IN_EMAIL_TECHNICAL_FAILURE';
const LAHI_SET_SEND_IN_EMAIL_SUCCESS = 'LAHI_SET_SEND_IN_EMAIL_SUCCESS';
const LAHI_SET_SEND_IN_EMAIL_CAPTCHA_ERROR = 'LAHI_SET_SEND_IN_EMAIL_CAPTCHA_ERROR';
const LAHI_SET_SELECTED_LAHIPRODUCT_JSON = 'LAHI_SET_SELECTED_LAHIPRODUCT_JSON';
const LAHI_SET_LAYOUT_CATEGORY = 'LAHI_SET_LAYOUT_CATEGORY';
const LAHI_SET_MINIMUM_PERCENT_TO_DISPLAY_ON_CHART = 'LAHI_SET_MINIMUM_PERCENT_TO_DISPLAY_ON_CHART';

const LAHI_CALCULATE_CTA_TA = 'KALKULATOR';
const LAHI_RE_CALCULATE_CTA_TA = 'UJRA_KALKULATOR';
const LAHI_CALCULATE_CTA_ERROR_TA = 'UJRA_TECHNIKAI_KALKULATOR';
const LAHI_SEND_IN_EMAIL_TA = 'EMAIL';

const createCalculationTaEvent = (state) => {
	let taEventPostFix = '_' + state.layoutCategory;
	let taEvent = '';
	if (state.hasCalculation) {
		taEvent = LAHI_RE_CALCULATE_CTA_TA;
	} else if (state.calculationTechnicalError) {
		taEvent = LAHI_CALCULATE_CTA_ERROR_TA;
	} else {
		taEvent = LAHI_CALCULATE_CTA_TA;
	}
	taEvent += taEventPostFix;
	return taEvent;
};
const lahiState = {
	lahiVhkModalId: null,
	ctaText: null,
	vhkOpenInModal: null,
	bookmarkId: '',
	calculatorTabs: [],
	sessionId: null,
	backendInitData: null,
	initTechnicalError: false,
	selectedTabIndex: null,
	selectedLahiProductIds: [],
	calculationResult: null,
	calculationInProgress: false,
	calculationTechnicalError: false,
	hasCalculation: false,
	allLahiProductIdJsons: [],
	calculationLahiProductIds: [],
	calculationLahiProductIdJsons: [],
	swJsonPath: '',
	selectedLahiProduct: null,
	isProductAprDiscounted: null,
	sendInEmailSuccess: false,
	sendInEmailTechnicalFailure: false,
	sendInEmailCapthcaError: false,
	selectedLahiProductJson: null,
	layoutCategory: null,
	minimumPercentToDisplayOnChart: null
};

const lahiGetters = {
	actualCalculatorTab(state) {
		return state.calculatorTabs[state.selectedTabIndex];
	}
};
const lahiActions = {
	getInitData({ commit, state }, selectedTabIndex) {
		commit(LAHI_SET_SELECTED_TAB_INDEX, selectedTabIndex);
		let lahiProductIdsArray = state.calculatorTabs[selectedTabIndex].lahiProductIds ? state.calculatorTabs[selectedTabIndex].lahiProductIds.split(',') : [];
		commit(LAHI_SET_LAHI_PRODUCT_IDS, lahiProductIdsArray);
		let dataToSend = {
			products: lahiProductIdsArray,
			sessionId: state.sessionId
		};
		lahiApi.getInitData(dataToSend).then(
			(response) => {
				commit(LAHI_SET_INIT_BACKEND_DATA, response.data);
				commit(LAHI_SET_SESSION_ID, response.data.sessionId);
				commit(LAHI_SET_MINIMUM_PERCENT_TO_DISPLAY_ON_CHART, response.data.minimumPercentToDisplayOnChart);
			},
			() => {
				commit(LAHI_SET_INIT_TECHNICAL_ERROR, true);
			}
		);
	},
	calculate({ commit, state, dispatch, getters }, data) {
		if (!state.calculationInProgress) {
			data.goal = state.calculatorTabs[state.selectedTabIndex].loanPurpose || '';
			data.highlighted = state.calculatorTabs[state.selectedTabIndex].featuredLahiProductId || '';
			data.order = state.calculatorTabs[state.selectedTabIndex].lahiProductIdsOrder || '';
			data.products = state.selectedLahiProductIds;
			data.sessionId = state.sessionId;
			data.uniqueOrder = state.calculatorTabs[state.selectedTabIndex].lahiProductIdsUniqueOrder
				? state.calculatorTabs[state.selectedTabIndex].lahiProductIdsUniqueOrder.split(',')
				: [];
			commit(LAHI_SET_CALCULATION_IN_PROGRESS, true);
			let taEvent = createCalculationTaEvent(state);
			let dataToSend = {
				content: data,
				taEvent
			};
			let gtmObject = {
				hasCalculation: state.hasCalculation,
				actualCalculatorTab: getters.actualCalculatorTab,
				data,
				backendInitData: state.backendInitData
			};
			lahiApi
				.calculate(dataToSend)
				.then(
					(response) => {
						gtmObject.technicalError = false;
						sendCalculationCtaGtm(gtmObject);
						commit(LAHI_SET_CALCULATION_RESULT, response.data);
						commit(LAHI_SET_HAS_CALCULATION, true);
						commit(LAHI_SET_CALCULATION_TECHNICAL_ERROR, false);
						let calculationLahiProductIds = [];
						if (response.data && response.data.products) {
							calculationLahiProductIds = response.data.products.map((product) => {
								return product.lahiId;
							});
						}
						commit(LAHI_SET_CALCULATION_LAHI_PRODUCT_IDS, calculationLahiProductIds);
						dispatch('checkAndGetLahiProductJsons');
					},
					() => {
						gtmObject.technicalError = true;
						sendCalculationCtaGtm(gtmObject);
						sendCalculationErrorGtm();
						commit(LAHI_SET_HAS_CALCULATION, false);
						commit(LAHI_SET_CALCULATION_TECHNICAL_ERROR, true);
					}
				)
				.finally(() => {
					commit(LAHI_SET_CALCULATION_IN_PROGRESS, false);
				});
		}
	},
	postEmailForm({ commit, state, dispatch }, data) {
		data.lahiId = state.selectedLahiProduct.lahiId;
		data.sessionId = state.sessionId;
		let taEvent = LAHI_SEND_IN_EMAIL_TA + '_' + state.layoutCategory;
		let dataToSend = {
			content: data,
			taEvent
		};
		dispatch('resetEmailFormStatus');
		lahiApi.postEmailForm(dataToSend).then(
			() => {
				commit(LAHI_SET_SEND_IN_EMAIL_SUCCESS, true);
			},
			() => {
				commit(LAHI_SET_SEND_IN_EMAIL_TECHNICAL_FAILURE, true);
			}
		);
	},
	resetEmailFormStatus({ commit }) {
		commit(LAHI_SET_SEND_IN_EMAIL_SUCCESS, false);
		commit(LAHI_SET_SEND_IN_EMAIL_TECHNICAL_FAILURE, false);
		commit(LAHI_SET_SEND_IN_EMAIL_CAPTCHA_ERROR, false);
	},
	checkAndGetLahiProductJsons({ dispatch, state }) {
		let unknownLahiProductIds = [];
		state.calculationLahiProductIds.forEach((calculationItem) => {
			let index = state.allLahiProductIdJsons.findIndex((allCalculationItem) => {
				return calculationItem == allCalculationItem.lahiId;
			});
			if (index == -1) {
				unknownLahiProductIds.push(calculationItem);
			}
		});
		dispatch('getLahiProductJson', unknownLahiProductIds);
	},
	getLahiProductJson({ commit, state, dispatch }, lahiProductIds) {
		let promises = lahiProductIds.map((item) => {
			return lahiApi.getLahiProductJson(item, state.swJsonPath);
		});
		Promise.all(promises)
			.then((responses) => {
				let allLahiProductIdJsons = [
					...state.allLahiProductIdJsons,
					...responses.map((item) => {
						return item.data;
					})
				];
				commit(LAHI_SET_ALL_LAHI_PRODUCT_ID_JSONS, allLahiProductIdJsons);
				dispatch('setCalculationLahiProductIdJsons');
			})
			.catch(() => {
				commit(LAHI_SET_HAS_CALCULATION, false);
				commit(LAHI_SET_CALCULATION_TECHNICAL_ERROR, true);
			});
	},
	setCalculationLahiProductIdJsons({ state, commit }) {
		let calculationLahiProductIdJsons = state.calculationLahiProductIds.map((calculationLahiId) => {
			let lahiIdJson = state.allLahiProductIdJsons.find((jsonItem) => {
				return jsonItem.lahiId == calculationLahiId;
			});
			let calculationResultObject = state.calculationResult.products.find((resultItem) => {
				return resultItem.lahiId == calculationLahiId;
			});
			lahiIdJson.commonName = calculationResultObject.commonName;
			return lahiIdJson;
		});
		commit(LAHI_SET_CALCULATION_LAHI_PRODUCT_ID_JSONS, calculationLahiProductIdJsons);
	},
	selectLahiLoan({ state, commit }, { lahiProduct, postData, taEventPrefix }) {
		commit(LAHI_SET_SELECTED_LAHI_PRODUCT, lahiProduct);
		let selectedLahiProductJson = state.allLahiProductIdJsons.find((item) => {
			return item.lahiId == lahiProduct.lahiId;
		});
		commit(LAHI_SET_SELECTED_LAHIPRODUCT_JSON, selectedLahiProductJson);
		if (postData) {
			let dataToSend = {};
			dataToSend.content = {
				lahiId: lahiProduct.lahiId,
				sessionId: state.sessionId
			};
			if (taEventPrefix) {
				dataToSend.taEvent = taEventPrefix + '_' + state.layoutCategory;
			}
			lahiApi.selectLahiLoan(dataToSend);
		}
	},
	sendTa(context, taData) {
		return lahiApi.sendTa(taData);
	},
	setLahiVhkId({ commit }, lahiVhkModalId) {
		commit(LAHI_SET_VHK_MODAL_ID, lahiVhkModalId);
	},
	setCtaText({ commit }, ctaText) {
		commit(LAHI_SET_CTA_TEXT, ctaText);
	},
	setVhkOpenInModal({ commit }, vhkOpenInModal) {
		commit(LAHI_SET_VHK_OPEN_IN_MODAL, vhkOpenInModal);
	},
	setBookmarkId({ commit }, bookmarkId) {
		commit(LAHI_SET_BOOKMARK_ID, bookmarkId);
	},
	setCalculatorTabs({ commit }, calculatorTabs) {
		commit(LAHI_SET_CALCULATOR_TABS, calculatorTabs);
	},
	setSessionId({ commit }, sessionId) {
		commit(LAHI_SET_SESSION_ID, sessionId);
	},
	setSwJsonPath({ commit }, swJsonPath) {
		commit(LAHI_SET_SW_JSON_PATH, swJsonPath);
	},
	setSelectedLahiProduct({ commit, state }, index) {
		commit(LAHI_SET_SELECTED_LAHI_PRODUCT, state.calculationResult.products[index]);
	},
	setIsProductAprDiscounted({ commit }, isProductAprDiscounted) {
		commit(LAHI_SET_IS_PRODUCT_APR_DISCOUNTED, isProductAprDiscounted);
	},
	setLayoutCategory({ commit }, layoutCategory) {
		commit(LAHI_SET_LAYOUT_CATEGORY, layoutCategory);
	}
};

const lahiMutations = {
	[LAHI_SET_VHK_MODAL_ID](state, lahiVhkModalId) {
		state.lahiVhkModalId = lahiVhkModalId;
	},
	[LAHI_SET_CTA_TEXT](state, ctaText) {
		state.ctaText = ctaText;
	},
	[LAHI_SET_VHK_OPEN_IN_MODAL](state, vhkOpenInModal) {
		state.vhkOpenInModal = vhkOpenInModal;
	},
	[LAHI_SET_BOOKMARK_ID](state, bookmarkId) {
		state.bookmarkId = bookmarkId;
	},
	[LAHI_SET_CALCULATOR_TABS](state, calculatorTabs) {
		state.calculatorTabs = calculatorTabs;
	},
	[LAHI_SET_INIT_BACKEND_DATA](state, backendInitData) {
		state.backendInitData = backendInitData;
	},
	[LAHI_SET_INIT_TECHNICAL_ERROR](state, initTechnicalError) {
		state.initTechnicalError = initTechnicalError;
	},
	[LAHI_SET_SESSION_ID](state, sessionId) {
		state.sessionId = sessionId;
	},
	[LAHI_SET_SELECTED_TAB_INDEX](state, selectedTabIndex) {
		state.selectedTabIndex = selectedTabIndex;
	},
	[LAHI_SET_LAHI_PRODUCT_IDS](state, selectedLahiProductIds) {
		state.selectedLahiProductIds = selectedLahiProductIds;
	},
	[LAHI_SET_CALCULATION_RESULT](state, calculationResult) {
		state.calculationResult = calculationResult;
	},
	[LAHI_SET_CALCULATION_IN_PROGRESS](state, calculationInProgress) {
		state.calculationInProgress = calculationInProgress;
	},
	[LAHI_SET_CALCULATION_TECHNICAL_ERROR](state, calculationTechnicalError) {
		state.calculationTechnicalError = calculationTechnicalError;
	},
	[LAHI_SET_HAS_CALCULATION](state, hasCalculation) {
		state.hasCalculation = hasCalculation;
	},
	[LAHI_SET_CALCULATION_LAHI_PRODUCT_IDS](state, calculationLahiProductIds) {
		state.calculationLahiProductIds = calculationLahiProductIds;
	},
	[LAHI_SET_ALL_LAHI_PRODUCT_ID_JSONS](state, allLahiProductIdJsons) {
		state.allLahiProductIdJsons = allLahiProductIdJsons;
	},
	[LAHI_SET_SW_JSON_PATH](state, swJsonPath) {
		state.swJsonPath = swJsonPath;
	},
	[LAHI_SET_CALCULATION_LAHI_PRODUCT_ID_JSONS](state, calculationLahiProductIdJsons) {
		state.calculationLahiProductIdJsons = calculationLahiProductIdJsons;
	},
	[LAHI_SET_SELECTED_LAHI_PRODUCT](state, selectedLahiProduct) {
		state.selectedLahiProduct = selectedLahiProduct;
	},
	[LAHI_SET_IS_PRODUCT_APR_DISCOUNTED](state, isProductAprDiscounted) {
		state.isProductAprDiscounted = isProductAprDiscounted;
	},
	[LAHI_SET_SEND_IN_EMAIL_TECHNICAL_FAILURE](state, sendInEmailTechnicalFailure) {
		state.sendInEmailTechnicalFailure = sendInEmailTechnicalFailure;
	},
	[LAHI_SET_SEND_IN_EMAIL_SUCCESS](state, sendInEmailSuccess) {
		state.sendInEmailSuccess = sendInEmailSuccess;
	},
	[LAHI_SET_SEND_IN_EMAIL_CAPTCHA_ERROR](state, sendInEmailCapthcaError) {
		state.sendInEmailCapthcaError = sendInEmailCapthcaError;
	},
	[LAHI_SET_SELECTED_LAHIPRODUCT_JSON](state, selectedLahiProductJson) {
		state.selectedLahiProductJson = selectedLahiProductJson;
	},
	[LAHI_SET_LAYOUT_CATEGORY](state, layoutCategory) {
		state.layoutCategory = layoutCategory;
	},
	[LAHI_SET_MINIMUM_PERCENT_TO_DISPLAY_ON_CHART](state, amount) {
		state.minimumPercentToDisplayOnChart = amount;
	}
};

export default {
	namespaced: true,
	state: lahiState,
	getters: lahiGetters,
	mutations: lahiMutations,
	actions: lahiActions
};

/* eslint-enable max-lines */
